/**
 * Lógica de gestión de Procesos Automáticos (Tareas)
 * Migrado desde tareas.php para mejor mantenibilidad
 */

declare var Swal: any;

(window as any).initializeTasks = function () {
    const tableId = "#table_tareas";

    // Verificamos si la tabla existe en el DOM antes de inicializar
    if ($(tableId).length === 0) return;

    if ($.fn.DataTable.isDataTable(tableId)) {
        $(tableId).DataTable().ajax.reload(null, false);
        return;
    }

    // 1. Inicializar DataTable
    const dt = $(tableId).DataTable({
        ajax: {
            url: "/admin/tables/tareas",
            type: "POST",
        },
        language: {
            url: "//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json"
        }
    });
    
    (window as any).tableTareas = dt;
};

document.addEventListener('DOMContentLoaded', function () {
    (window as any).initializeTasks();

    const modalId = "#modal_task";
    const formId = "#form_task";

    // 2. Abrir Modal de Edición / Configuración
    $(document).on("click", "#table_tareas .btn-edit-task", function (this: HTMLElement) {
        const data = $(this).data();
        const row = $(this).closest('tr');
        const label = row.find('span.fw-bold').text();

        // Llenar campos
        $('#id_tarea').val(data.id || "");
        $('#tipo_tarea').val(data.tipo);
        $('#frecuencia_tarea').val(data.frecuencia);
        $('#hora_tarea').val(data.hora || "08:00:00");
        
        const statusCheckbox = document.getElementById("status_tarea") as HTMLInputElement;
        if (statusCheckbox) {
            statusCheckbox.checked = data.status == "1";
        }

        $('#task_label_display').text(label);
        $('#modal_title').text("Configurar Proceso");

        ($(modalId) as any).modal("show");
    });

    // 3. Guardar Cambios (Submit)
    $(document).on("submit", formId, function (this: HTMLFormElement, e: JQuery.SubmitEvent) {
        e.preventDefault();

        Swal.fire({
            title: 'Guardando configuración...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const formData = new FormData(this);
        const id_tarea = $('#id_tarea').val();
        const url = id_tarea ? "/admin/tareas/edit" : "/admin/tareas/create";

        fetch(url, {
            method: "POST",
            body: formData
        })
        .then(res => {
            if (!res.ok) throw new Error('Error en el servidor: ' + res.status);
            return res.json();
        })
        .then(data => {
            if (data.status == 200 || data.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Configuración guardada correctamente.',
                    timer: 1500,
                    showConfirmButton: false
                }).then(() => {
                    ($(modalId) as any).modal("hide");
                    if ((window as any).tableTareas) {
                        (window as any).tableTareas.ajax.reload(null, false);
                    }
                });
            } else {
                Swal.fire("Error", "La API respondió: " + (data.message || "Error desconocido"), "error");
            }
        })
        .catch(error => {
            console.error("Error al guardar:", error);
            Swal.fire("Error", "No se pudo conectar con el servidor. Revisa tu conexión o intenta más tarde.", "error");
        });
    });
});
